export default __webpack_public_path__ + "static/Red-Hot-Gloss-Homepage-Banner-Desktop-W1-a53cdd5e27d66aa3920ba0fa044010d3.webp";